import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classNames from "classnames";

import styles from "./ContentSelector.css";
import TextInput from "components/library/TextInput";
import Icon from "components/library/Icon";
import Label from "components/library/Label";
import { getContentAsync } from "actions/items";
import Button from "../Button/Button";
import { UUID_REGEXP } from "config/constants";

class ContentSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: undefined,
      isExpanded: false,
      storyUrlInputValue: "",
    };

    this.submitForm = this._submitForm.bind(this);
  }

  _submitForm(event) {
    event.preventDefault();

    const match = UUID_REGEXP.exec(this.state.storyUrlInputValue);
    if (!match) {
      this.setState({
        error:
          "URL is not in correct format. Please make sure it contains a story ID.",
      });
      return;
    }
    const uuid = match[1];

    if (this.props.validateSelection) {
      const validation = this.props.validateSelection(uuid);
      if (validation.error) {
        this.setState({ error: validation.error });
        return;
      }
    }
    this.props.getContentAsync(match[1]).then(action => {
      if (action.payload.id) {
        this.setState({ storyUrlInputValue: "" });
        this.props.onContentLookup(action);
      } else {
        this.setState({
          error:
            "Failed to fetch story. Check the URL, or try again in a moment.",
        });
      }
    });
  }

  render() {
    const { isExpanded, storyUrlInputValue, error } = this.state;
    const { label = "Add a story" } = this.props;
    if (!isExpanded) {
      return (
        <Button
          className={classNames(styles.root, styles.addButton)}
          onClick={() => this.setState({ isExpanded: true })}
        >
          <Icon name="plus" className={styles.plusIcon} /> Add a story
        </Button>
      );
    }
    return (
      <div className={classNames(styles.root, styles.isExpanded)}>
        <Label className={styles.formLabel}>{label}</Label>
        <form onSubmit={this.submitForm}>
          <TextInput
            fullWidth
            label="Story URL"
            type="text"
            value={storyUrlInputValue}
            onChange={e =>
              this.setState({
                storyUrlInputValue: e.target.value,
                error: undefined,
              })
            }
            placeholder="Paste a story's URL"
            error={
              error && {
                message: error,
                title: "Story Selection Error",
              }
            }
          />

          <div className={styles.formButtons}>
            <Button htmlType="submit" type="secondary">
              Add Story
            </Button>
            <Button
              type="tertiary"
              onClick={() =>
                this.setState({
                  error: undefined,
                  isExpanded: false,
                  storyUrlInputValue: "",
                })
              }
              htmlType="button"
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = {
  getContentAsync,
};

ContentSelector.propTypes = {
  getContentAsync: PropTypes.func.isRequired,
  validateSelection: PropTypes.func,
  onContentLookup: PropTypes.func,
  label: PropTypes.string,
};

export default connect(
  null,
  mapDispatchToProps
)(ContentSelector);
